function renderImageOnHover(el, srcImg, imgHeight, imgWidth){

    const index = Array.from(
        el.parentElement.children
      ).indexOf(el);

    const RowHeights = [];
    Array.from(el.parentElement.children).forEach( (element,indexEl) =>  {
        if(indexEl%3 === 0){
            RowHeights.push(element.offsetHeight);
        }
    })

    if(el.getAttribute('title')){
        el.setAttribute('titleAttr',el.getAttribute('title'));
        el.removeAttribute('title');
    }
    el.parentElement.style.position = 'relative';
    const imageElement = document.createElement("img");
    imageElement.style.position = 'absolute';
    imageElement.style.width = `${imgWidth}px`;
    imageElement.style.height = `${imgHeight}px`;
    
    if(el.getAttribute('titleAttr').startsWith('Sidebar') === true || ( el.getAttribute('titleAttr').startsWith('Table') === true && el.getAttribute('titleAttr') !== 'Table Template')){
        const indexOfRow = Math.floor(index/3);
        let yDistance = 0;
        RowHeights.forEach( (rowDist,indexEl) => {
            if(indexEl < indexOfRow){
                yDistance += 10 + rowDist;
            }
        })
        imageElement.style.top = `${-imgHeight + yDistance}px`;
    }
    else{
        const indexOfRow = Math.floor(index/3);
        let yDistance = 0;
        RowHeights.forEach( (rowDist,indexEl) => {
            if(indexEl <= indexOfRow){
                yDistance += 10 + rowDist;
            }
        })
        imageElement.style.top = `${yDistance}px`;
    }
    if(index%3 === 0){
        imageElement.style.left = '0px';
    }
    else if(index%3 === 1){
        imageElement.style.right = `${1.5 * el.offsetWidth + 15 - (imgWidth/2)}px`;
    }
    else if(index%3 === 2){
        imageElement.style.right = '0px';   
    }
    imageElement.src = srcImg;
    imageElement.style.border = "5px solid #000";
    imageElement.style.borderRadius = '0.5rem';
    imageElement.style.zIndex ='5';
    imageElement.style.display = 'none'
    imageElement.onload = () => {
        imageElement.loaded = true;
        imageElement.style.display = "inherit";
    }
    el.parentElement.appendChild(imageElement);

}

function removeHoverImage(el){

    const insideImage = el.parentElement.getElementsByTagName('img')[0];

    if(insideImage){
        insideImage.remove();
    }
}

function displayOnBlockHoverImages(title, srcImg, imgHeight, imgWidth){
    const blogHomeTemplateBlock = document.querySelector(`[title = "${title}"]`);
    if(blogHomeTemplateBlock){
        blogHomeTemplateBlock.addEventListener("mouseover",() => renderImageOnHover(blogHomeTemplateBlock,srcImg, imgHeight, imgWidth ), false);
        blogHomeTemplateBlock.addEventListener("mouseout", () => removeHoverImage(blogHomeTemplateBlock), false);
    }
}

const handleBlocks = (editor,savedPageClicked) => {

    editor.on('block', (block) => {

        if(block.event === 'update' ){
            if(block.model.models[block.model.length-1].attributes.attributes.customBlock){
                const blockLabel = block.model.models[block.model.length-1].attributes.label;
                const blockElement = document.querySelector(`[title = "${blockLabel}"]`);
                if(blockElement !== null){
                    blockElement.style.position = 'relative';
                    const closeButton = document.createElement('div');
                    closeButton.style.position = 'absolute';
                    closeButton.style.right = '2px';
                    closeButton.style.cursor = "pointer";
                    closeButton.style.fontSize = "1rem";
                    closeButton.classList.add("fa");
                    closeButton.classList.add("fa-times");
                    closeButton.setAttribute('blockId', block.model.models[block.model.length-1].id);
                    closeButton.onclick = (blockEl) => {
                        editor.BlockManager.remove(blockEl.target.attributes.blockid.value);
                        const tempData = JSON.parse(localStorage.getItem('data'));
                        const selectedProject =JSON.parse(localStorage.getItem('selectedProject'));
                        tempData[selectedProject].customBlocks = tempData[selectedProject].customBlocks.filter( customBlock => customBlock.content.id !== blockEl.target.attributes.blockid.value);
                        localStorage.setItem('data',JSON.stringify(tempData));
                        savedPageClicked();
                    } 
                    blockElement.append(closeButton);
                }
                
            }                   
        }

    })

    editor.on('block:add', (block) => {
        let blocks;
        // if(block.attributes.id === 'blogHome'){
        //     blocks = editor.BlockManager.getAll().filter( blockEl => blockEl.attributes.id !== 'blogHome').map( blockEl => editor.BlockManager.get(blockEl.attributes.id));
        //     // editor.BlockManager.render([editor.BlockManager.get('blogHome'),...blocks]);
        // }
        if (block.attributes.id === 'planTemplate') {
          blocks = editor.BlockManager.getAll()
            .filter(
              (blockEl) =>
                blockEl.attributes.id !== 'planTemplate' &&
                blockEl.attributes.id !== 'usersListTemplate' &&
                blockEl.attributes.id !== 'navbar3' &&
                blockEl.attributes.id !== 'login3' &&
                blockEl.attributes.id !== 'delivery' &&
                blockEl.attributes.id !== 'contactForm' &&
                blockEl.attributes.id !== 'simpleForm' &&
                blockEl.attributes.id !== 'listTemplate2' &&
                blockEl.attributes.id !== 'taskTable' 
            )
            .map((blockEl) => editor.BlockManager.get(blockEl.attributes.id));
          editor.BlockManager.render([
            editor.BlockManager.get('usersListTemplate'),
            editor.BlockManager.get('planTemplate'),
            editor.BlockManager.get('navbar3'),
            editor.BlockManager.get('login3'),
            editor.BlockManager.get('delivery'),
            editor.BlockManager.get('contactForm'),
            editor.BlockManager.get('simpleForm'),
            editor.BlockManager.get('listTemplate2'),
            editor.BlockManager.get('taskTable'),
            ...blocks,
          ]);

            const categories = editor.BlockManager.getCategories();
            categories.each(category => {
                category.set('open', false).on('change:open', opened => {
                    opened.get('open') && categories.each(category2 => {
                        category2 !== opened && category2.set('open', false)
                    })
                })
            })
        }
        if(block.attributes.id === 'planTemplate'){
            
            //  Built in Templates
            displayOnBlockHoverImages('Users List Template','/images/Blocks/UsersList.png',200,250);
            displayOnBlockHoverImages('User Task Template','/images/Blocks/UserPlan.png',239,250)
            displayOnBlockHoverImages('User Information Template','/images/Blocks/UserInformation.png',250,250);
            displayOnBlockHoverImages('Blog Home Template','/images/Blocks/BlogHomeTemplate.png',200,144);
            displayOnBlockHoverImages('Blog Post Template','/images/Blocks/BlogPostTemplate.png',200,158);
            displayOnBlockHoverImages('Shop List Template','/images/Blocks/ShopListTemplate.png',200,190);
            displayOnBlockHoverImages('Shop Item Template','/images/Blocks/ShopItemTemplate.png',200,166);
            displayOnBlockHoverImages('Form Template','/images/Blocks/FormTemplate.png',152,200);
            displayOnBlockHoverImages('Table Template','/images/Blocks/TableTemplate.png',137,200);
            displayOnBlockHoverImages('Modern Business Template','/images/Blocks/ModernBusinessTemplate.png',200,104);
            displayOnBlockHoverImages('Business Frontpage Template','/images/Blocks/BusinessFrontPageTemplate.png',200,92);
            displayOnBlockHoverImages('List Template','/images/Blocks/ListTemplate.png',195,200);
            displayOnBlockHoverImages('Item Template','/images/Blocks/ItemTemplate.png',200,172)

            // Built in Components
            // displayOnBlockHoverImages('User Plan','/images/Blocks/Form.png',239,250);
            displayOnBlockHoverImages('Payment Component','/images/Blocks/Payment.png',239,250);
            displayOnBlockHoverImages('Comment Section','/images/Blocks/CommentSection.png',239,250);
            displayOnBlockHoverImages('Comparison Grid','/images/Blocks/ComparisonGrid.png',239,300);
            displayOnBlockHoverImages('Comparison Card','/images/Blocks/ComparisonCard.png',49,250);
            displayOnBlockHoverImages('FAQ Template','/images/Blocks/FAQTemplate.png',125,250);
            displayOnBlockHoverImages('Invoice','/images/Blocks/Invoice.png',250,250);
            displayOnBlockHoverImages('Order Details','/images/Blocks/OrderDetails.png',250,250);
            displayOnBlockHoverImages('Gallery Grid','/images/Blocks/GalleryGrid.png',250,250);
            displayOnBlockHoverImages('User Profile','/images/Blocks/UserProfile.png',250,250);
            displayOnBlockHoverImages('Weather Widget','/images/Blocks/WeatherWidget.png',85,85);
            displayOnBlockHoverImages('User Information','/images/Blocks/UserInformation.png',250,250);

            // Headers & Footers
            displayOnBlockHoverImages('Sticky Footer','/images/Blocks/StickyFooter.png',82,125);
            displayOnBlockHoverImages('Media Footer','/images/Blocks/MediaFooter.png',45,250);
            displayOnBlockHoverImages('Footer','/images/Blocks/Footer.png',119,250);
            displayOnBlockHoverImages('Sidebar Header','/images/Blocks/SidebarHeader.png',120,205);
            displayOnBlockHoverImages('Header','/images/Blocks/Navbar1.png',32,250);
            displayOnBlockHoverImages('Header for User','/images/Blocks/Navbar2.png',56,250);

            // Login & Register
            displayOnBlockHoverImages('Login With Logo','/images/Blocks/LoginWithLogo.png',140,250);
            displayOnBlockHoverImages('Login With Social','/images/Blocks/LoginWithSocial.png',140,250);
            displayOnBlockHoverImages('Login With Image','/images/Blocks/LoginWithImage.png',140,250);
            displayOnBlockHoverImages('Sign Up','/images/Blocks/SignUp.png',140,250);

            //  Forms
            displayOnBlockHoverImages('Delivery Form','/images/Blocks/DeliveryForm.png',150,250);
            displayOnBlockHoverImages('Simple Form','/images/Blocks/SimpleForm.png',239,250);
            displayOnBlockHoverImages('Contact Form','/images/Blocks/ContactForm.png',150,250);
            displayOnBlockHoverImages('Plain Form','/images/Blocks/Form.png',239,250);
            displayOnBlockHoverImages('Input','/images/Blocks/Input.png',49,250);
            displayOnBlockHoverImages('Textarea','/images/Blocks/Textarea.png',84,250);
            displayOnBlockHoverImages('Select','/images/Blocks/Select.png',62,250);
            displayOnBlockHoverImages('Label','/images/Blocks/Label.png',57,62);
            displayOnBlockHoverImages('Checkbox','/images/Blocks/Checkbox.png',58,250);
            displayOnBlockHoverImages('Radio','/images/Blocks/Radio.png',53,125);
            displayOnBlockHoverImages('Date field','/images/Blocks/Date.png',85,250);
            displayOnBlockHoverImages('Array Input','/images/Blocks/ArrayInput.png',65,250);
            displayOnBlockHoverImages('Array Input Select','/images/Blocks/ArrayInputSelect.png',59,250);
            displayOnBlockHoverImages('Select2','/images/Blocks/Select2.png',35,250);

            // List Items
            displayOnBlockHoverImages('Users List','/images/Blocks/UsersList.png',200,250);
            displayOnBlockHoverImages('Task List','/images/Blocks/TaskList.png',115,250);
            displayOnBlockHoverImages('List Posts','/images/Blocks/ListItems.png',99,250);
            displayOnBlockHoverImages('Grid Posts','/images/Blocks/GridItems.png',250,115);
            displayOnBlockHoverImages('List with pagination','/images/Blocks/ListWithPagination.png',72,250);

            //  Layout
            displayOnBlockHoverImages('1 Column','/images/Blocks/1Column.png', 89, 250);
            displayOnBlockHoverImages('2 Columns','/images/Blocks/2Columns.png',90, 250);
            displayOnBlockHoverImages('3 Columns','/images/Blocks/3Columns.png', 90, 250);
            displayOnBlockHoverImages('2 Columns 3/7','/images/Blocks/2Columns37.png',91,250);
            displayOnBlockHoverImages('Box','/images/Blocks/Box.png',88, 250);
            // displayOnBlockHoverImages('Pair Texts','/images/Blocks/PairTexts.png',33,250);

            // Tables
            displayOnBlockHoverImages('Task Table','/images/Blocks/TaskTable.png',120,250);
            displayOnBlockHoverImages('Comparison Table','/images/Blocks/ComparisonTable.png',120,250);
            displayOnBlockHoverImages('Simple Table','/images/Blocks/Table1.png',47,250);
            displayOnBlockHoverImages('Table','/images/Blocks/Table2.png',143,250);

            //  Typography
            displayOnBlockHoverImages('Text','/images/Blocks/Text.png',64,250);
            displayOnBlockHoverImages('Link','/images/Blocks/Link.png',64,125);
            displayOnBlockHoverImages('Text section','/images/Blocks/TextSection.png',64,250);
            displayOnBlockHoverImages('Heading 1','/images/Blocks/Heading1.png',60,250);
            displayOnBlockHoverImages('Heading 2','/images/Blocks/Heading2.png',47,250);
            displayOnBlockHoverImages('Heading 3','/images/Blocks/Heading3.png',46,250);
            displayOnBlockHoverImages('Paragraph','/images/Blocks/Paragraph.png',147,250);
            displayOnBlockHoverImages('Horizontal Rule','/images/Blocks/HorizontalRule.png',32,250);

            //  Components
            displayOnBlockHoverImages('Image','/images/Blocks/Image.png',125,123);
            displayOnBlockHoverImages('Map','/images/Blocks/Map.png',105, 125);
            displayOnBlockHoverImages('Tabs','/images/Blocks/Tabs.png',66,125);
            displayOnBlockHoverImages('Accordion','/images/Blocks/Accordion.png',112,250);
            displayOnBlockHoverImages('Badge','/images/Blocks/Badge.png',30,250);
            displayOnBlockHoverImages('Breadcrumb','/images/Blocks/Breadcrumb.png',32, 250);
            displayOnBlockHoverImages('Card','/images/Blocks/Card.png',250,148);
            displayOnBlockHoverImages('Carousel','/images/Blocks/Carousel.png', 125,122);
            displayOnBlockHoverImages('Collapse','/images/Blocks/Collapse.png',116,250);
            displayOnBlockHoverImages('List Group','/images/Blocks/ListGroup.png',87,250);
            displayOnBlockHoverImages('Modal','/images/Blocks/Modal.png',86,250);
            displayOnBlockHoverImages('Pagination 1','/images/Blocks/Pagination1.png',31,250);
            displayOnBlockHoverImages('Pagination 2','/images/Blocks/Pagination2.png',33,250);
            displayOnBlockHoverImages('Pagination 3','/images/Blocks/Pagination3.png',27,250);
            displayOnBlockHoverImages('Scrollspy','/images/Blocks/Scrollspy.png',250,223);
            displayOnBlockHoverImages('Radios','/images/Blocks/Radios.png',57,250);
            displayOnBlockHoverImages('Inline radios','/images/Blocks/InlineRadios.png',48,125);
            displayOnBlockHoverImages('Switch','/images/Blocks/Switch.png',35,250);
            displayOnBlockHoverImages('Upload image','/images/Blocks/UploadImage.png',52,250);

            

            //  Buttons
            displayOnBlockHoverImages('Button','/images/Blocks/Button.png',60,94);
            displayOnBlockHoverImages('Manage Button','/images/Blocks/ManageButton.png',60,137);
            displayOnBlockHoverImages('Archive Button','/images/Blocks/ArchiveButton.png',60,134);
            displayOnBlockHoverImages('Delete Button','/images/Blocks/DeleteButton.png',60,136);
            displayOnBlockHoverImages('Previous Button','/images/Blocks/PreviousButton.png',60,151);
            displayOnBlockHoverImages('Next Button','/images/Blocks/NextButton.png',60,151);
            displayOnBlockHoverImages('Dropdown','/images/Blocks/DropdownButton.png',60,213);
            displayOnBlockHoverImages('Button Group','/images/Blocks/ButtonGroup.png',54,250);

            //  Extra
            displayOnBlockHoverImages('Custom Code','/images/Blocks/CustomCode.png',67,250);
            displayOnBlockHoverImages('Tooltip','/images/Blocks/Tooltip.png',58,60);



            //  Sidebars
            displayOnBlockHoverImages('Sidebar1','/images/Blocks/Sidebar1.png',83,250);
            displayOnBlockHoverImages('Sidebar2','/images/Blocks/Sidebar2.png',144,250);
            displayOnBlockHoverImages('Sidebar3','/images/Blocks/Sidebar3.png',105,250);
            displayOnBlockHoverImages('Sidebar4','/images/Blocks/Sidebar4.png',143,250);
            displayOnBlockHoverImages('Sidebar5','/images/Blocks/Sidebar5.png',135,250);
            displayOnBlockHoverImages('Sidebar6','/images/Blocks/Sidebar6.png',135,200);
            
             
            //  Final block
            setTimeout(() => displayOnBlockHoverImages('User Plan','/images/Blocks/UserPlan.png',239,250), 500); 
        
        }

        
    })

    document.addEventListener("dragstart", event => {
        const dragged = event.target;
        const titleAttr = dragged.getAttribute('titleAttr');
        if(titleAttr){
            const blogHomeTemplateBlock = document.querySelector(`[titleAttr = "${titleAttr}"]`);
            if(blogHomeTemplateBlock){
                removeHoverImage(blogHomeTemplateBlock);
            }
        }
    });


}

export  default handleBlocks;